import React, { Component } from 'react';
import PropTypes from "prop-types";
import ImageCarouselView from "./ImageCarouselView";
import Money from "../../utils/Money";
import Text from "../../utils/Text";


export default class PublicSpaceCardView extends Component {

    static propTypes = {
        spaceId: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        pricePerDay: PropTypes.number.isRequired,
        minimumDays: PropTypes.number.isRequired,
        distance: PropTypes.number.isRequired,
        created: PropTypes.number.isRequired,
        selected: PropTypes.bool.isRequired,
        imageNames: PropTypes.arrayOf(PropTypes.string).isRequired,
    };

    render() {
        return (
            <div className={(this.props.selected) ? "card-selected card mb-2 shadow p-3 bg-white rounded border-top-box" : "card mb-2 shadow p-3 bg-white rounded border-top-box"}>
                <ImageCarouselView id={this.props.spaceId} imageNames={this.props.imageNames} viewHeightSize={25}/>
                <div className="card-body" id={this.props.spaceId}>
                    <div className="row mb-0">
                        <div className="col-8">
                            <a
                                className="btn p-0"
                                href={"/space/details/" + this.props.spaceId}
                                target="_blank"
                                rel="noreferrer"
                            >
                                <h6 className="card-title bold-contents-text">{this.props.title}</h6>
                            </a>
                        </div>
                        <div className="col-4">
                            <div className="row ">
                                <div className="col text-right pl-0">
                                    {Money.formatMoney(this.props.pricePerDay)} <small>/ day</small>
                                </div>
                            </div>
                            <div className="row card-subtitle">
                                <div className="col text-right">
                                    <small>
                                        min. {this.props.minimumDays} days
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <p className="card-text text-muted">{Text.truncate(this.props.description, 100, true)}</p>
                    <div className="col text-center">
                        <a
                            className="btn btn-secondary"
                            href={"/space/details/" + this.props.spaceId}
                            target="_blank"
                            rel="noreferrer"
                        >
                            Details
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

